(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/endpoints/favorites-api.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/endpoints/favorites-api.js');
"use strict";


const jupiterFetch = svs.core.jupiterFetch;
const _RTKQ = RTKQ,
  fetchBaseQuery = _RTKQ.fetchBaseQuery,
  createApi = _RTKQ.createApi;
const _svs$components$casin = svs.components.casino.preferences,
  CasinoPreferenceNames = _svs$components$casin.CasinoPreferenceNames,
  getPreferences = _svs$components$casin.getPreferences,
  putPreference = _svs$components$casin.putPreference,
  isCloudPreferencesEnabled = _svs$components$casin.isCloudPreferencesEnabled;
const toErrorResult = error => ({
  error: {
    status: error.status,
    data: error.message,
    message: error.message
  }
});
const createGetFavoritesEndpoint = builder => builder.query({
  async queryFn(arg, api, extraOptions, baseQuery) {
    if (!(await isCloudPreferencesEnabled())) {
      const result = await baseQuery('/casino/1/favorites');
      return result.error ? result : {
        data: result.data.favorites || []
      };
    }
    try {
      const casinoPreferences = await getPreferences();
      return {
        data: casinoPreferences.favorites
      };
    } catch (error) {
      return toErrorResult(error);
    }
  },
  providesTags: ['Favorites']
});
const createUpdateFavoritesEndpoint = builder => builder.mutation({
  async queryFn(favorites, api, extraOptions, baseQuery) {
    if (!(await isCloudPreferencesEnabled())) {
      return baseQuery({
        url: "/casino/1/favorites?favorites=".concat(encodeURIComponent(favorites.join(';'))),
        method: 'PUT'
      });
    }
    try {
      await putPreference({
        name: CasinoPreferenceNames.FAVORITES,
        values: favorites
      });
      return {
        data: undefined
      };
    } catch (error) {
      return toErrorResult(error);
    }
  },
  invalidatesTags: ['Favorites']
});
const favoritesApi = createApi({
  reducerPath: 'favoritesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: jupiterFetch.url(),
    fetchFn: jupiterFetch.fetch,
    prepareHeaders: headers => {
      headers.set('Content-Type', 'application/json');
      return headers;
    }
  }),
  tagTypes: ['Favorites'],
  endpoints: builder => ({
    getFavorites: createGetFavoritesEndpoint(builder),
    updateFavorites: createUpdateFavoritesEndpoint(builder)
  })
});
setGlobal('svs.components.casino_react.casinoStore.endpoints.favoritesApi', favoritesApi);

 })(window);